import {
  Button,
  Flex,
  Spacer,
  Box,
  Avatar, Image, Menu, MenuButton, MenuList, MenuItem, DarkMode, Text, Tooltip, Link, Spinner,
  useDisclosure,
  useColorModeValue,
  useBreakpointValue,
  VStack,
  Divider, 
} from "@chakra-ui/react"
import React from 'react'; // Ensure React is explicitly imported

import { ColorModeSwitcher } from "../../ColorModeSwitcher" ;
import { useNavigate } from "react-router-dom";

import eduviclogo from "../../resources/Eduvictechlogo.png";
import { useState } from "react";
import { jwtDecode } from "jwt-decode";
import { useLocation } from "react-router-dom";
import { useTenant } from "../Routers/TenantContextProvider";


interface NavBarPlatformProps {
  isAuthenticated: boolean;
  onLogout: () => void;
  userInitials: string | null;
  tenantName: string | null;
  logoUrl: string | null;
  tenantSlug: string | null;
}

const NavBarPlatform: React.FC<NavBarPlatformProps> = ({ isAuthenticated, onLogout, userInitials ,tenantName,logoUrl, tenantSlug}) => {
  const navigate = useNavigate();
  const [hover, setHover] = useState(false);
 // const [isOpen, setIsOpen] = useState(false);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const isMobile = useBreakpointValue({ base: true, md: false });

  const token = localStorage.getItem("token");
  //const tenantSlug = localStorage.getItem("tenantSlug");

  const location = useLocation();
//const { tenant, loading } = useTenant();

/* // Handle initial loading state
if (loading) {
  return <Spinner />; // Or skeleton UI
} */

//  const tenantSlug = tenant?.tenant_slug;

  console.log("tenant slug from Navbar Platform", tenantSlug);

  const hideLoginButton =
  location.pathname.includes("/login") ||
  !tenantSlug; // No tenantSlug — likely at /platform

  const handleLogin = () =>
    { navigate(`/platform/${tenantSlug}/login/`);
    }


  // Function to determine dashboard route based on role
  const getHomeRoute = () => {
  // Not authenticated
  if (!isAuthenticated) {
    return `/platform/`; // Generic landing page for all users (tenant-specific or not)
  }

  // Authenticated but no token – corrupted session
  if (!token) {
    return tenantSlug ? `/platform/${tenantSlug}/login/` : `/platform/`;
  }

  // Authenticated and token exists – try decoding
  try {
    const decoded: { role_id: number } = jwtDecode(token);

    switch (decoded.role_id) {
      case 1:
        return `/platform/super/`; // Super admin dashboard
      case 2:
      case 3:
      case 4:
        return `/platform/${tenantSlug}/app/`; // Regular tenant user dashboard
      default:
        console.warn("Unknown role_id:", decoded.role_id);
        return `/platform/${tenantSlug}/login/`; // Meaningful fallback for unsupported roles
    }
  } catch (err) {
    console.error("Invalid or corrupted token:", err);
    return tenantSlug ? `/platform/${tenantSlug}/login/` : `/platform/`; // Force login again
  }
};


    return (
     
  
        <Flex
        as="nav"
        bg="blue.600" 
       // opacity="0.9"
        boxShadow="2xl"
        p={2}
        align="center"
        justify="space-between"
        position="fixed"
        top="0"
        width="full"
        zIndex="sticky"
        height="70px" // Adjust height as needed
     
      >     
            <Image 
            src={eduviclogo} 
            alt="Logo" 
            boxSize="80px" 
            objectFit="contain" 
            border="md" 
            style={{
              cursor: hover ? 'pointer' : 'default',
              transition: '0.3s' // optional for smooth transition
            }}
            onClick={() => navigate(getHomeRoute())}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            />

{/*             <Text
                    fontWeight="bold"
                    color="white"
                    fontSize="md"
                    whiteSpace="nowrap"
                  //  overflow="hidden"
                  //  textOverflow="ellipsis"
                    title={"Eduvic Platform"}
                    >
                    Learning Platform
                    </Text> */}

                        {!isMobile && (
                          <Text
                            fontWeight="bold"
                            color="gray.300"
                            fontSize={{ base: "sm", lg: "md" }}
                            whiteSpace="nowrap"
                            overflow="hidden"
                            textOverflow="ellipsis"
                          >
                            Learning Platform
                          </Text>
                        )}
           {/*  
            
              {/* Left Side Links */}
            {!isMobile && (
              <Flex as="nav" p={0} alignItems="center" >
                <Box
                >
            
                </Box>
              </Flex>
             
            )}

              {/* Spacer pushes the right-aligned buttons to the far right */}
              <Spacer />
            {/* Show tenant logo and name if available */}
              {/* Show tenant logo and name if available */}
               {/* <Divider orientation="vertical" borderColor="white" mr={2}/> */}
                {tenantSlug && (
                <Flex
                    align="center"
                    gap={2}
                    maxW={{ base: "140px", md: "200px" }}
                    mr={{ base: 2, md: 4 }}
                    isTruncated
                >
                    <Text
                    fontWeight="bold"
                    color="blue.100"
                    fontSize="md"
                    whiteSpace="nowrap"
                    overflow="hidden"
                    textOverflow="ellipsis"
                    title={tenantName ?? ""}
                    >
                    {tenantName}
                    </Text>

                    <Image
                    src={logoUrl ?? undefined}
                    alt={tenantName ?? undefined}
                    boxSize="50px"
                    borderRadius="full"
                    objectFit="cover"
                    flexShrink={0}
                    />
 
                </Flex>
                )}
           
            <Divider orientation="vertical" borderColor="white" mr={2}/>

            <Flex gap={4} align="center">
            {isAuthenticated ? (
              
                <>
                
                {/* Show initials avatar if available */}
                {userInitials && (
                    <Avatar
                    name={userInitials}
                    bg="blue.500"
                    color="white"
                    size="sm"
                    showBorder={false}
                    getInitials={() => userInitials}
                    />
                )}
                <Button
                    variant="outline"
                    mr={4}
                    _hover={{ bg: "blue.400" }}
                    color="white"
                    fontSize="md"
                    onClick={onLogout}
                >
                    Logout
                </Button>
                <ColorModeSwitcher justifySelf="flex-end" _hover={{bg :"blue.400"} }/> 
                </>
            ) : (
                !hideLoginButton && (
                <Button
                    variant="outline"
                    _hover={{ bg: "blue.400" }}
                    color="white"
                    fontSize="md"
                    onClick={handleLogin}
                >
                    Login
                </Button>
                )
            )}
            </Flex>
          

      </Flex>   
    );
  };

  export default NavBarPlatform;